import {
	BASE_TEMPLATE_ID,
	BASE_TEMPLATE_NAME,
	createBaseTemplate,
} from './template-one/config';
import {
	BannerContent,
	TemplateDesign,
	TextKey,
	TypographySettings,
} from '../types';

export {
	BASE_MEDIA_ASSETS,
	BASE_TEMPLATE_ID,
	BASE_TEMPLATE_NAME,
	BASE_TEMPLATE_THUMBNAIL,
	createBaseTemplate,
} from './template-one/config';

/**
 * @param id Template id.
 */
export const isBaseTemplate = ( id: string ): boolean =>
	id === BASE_TEMPLATE_ID;

/**
 * Template of a banner, falling back to the base template when the
 * template was deleted.
 *
 * @param templates Template library.
 * @param id        Template id.
 */
export const findTemplate = (
	templates: TemplateDesign[],
	id: string
): TemplateDesign =>
	templates.find( ( template ) => template.id === id ) ||
	templates.find( ( template ) => isBaseTemplate( template.id ) ) ||
	createBaseTemplate();

/**
 * @param templates Template library.
 * @param id        Template id.
 */
export const getTemplateName = (
	templates: TemplateDesign[],
	id: string
): string =>
	templates.find( ( template ) => template.id === id )?.name ||
	BASE_TEMPLATE_NAME;

/**
 * Text style of the template with the banner's own text.
 *
 * @param design  Template.
 * @param content Banner content.
 * @param key     Text element.
 */
export const resolveText = (
	design: TemplateDesign,
	content: BannerContent,
	key: TextKey
): TypographySettings => ( {
	...design.typography[ key ],
	text: content.texts[ key ] ?? design.typography[ key ].text,
} );

/**
 * Banner content filled with a template's sample texts.
 *
 * @param design Template.
 */
export const createContentFromTemplate = (
	design: TemplateDesign
): BannerContent => ( {
	texts: ( Object.keys( design.typography ) as TextKey[] ).reduce(
		( texts, key ) => ( {
			...texts,
			[ key ]: design.typography[ key ].text,
		} ),
		{} as Record< TextKey, string >
	),
	ctaLink: '',
	ctaNewTab: false,
} );

/**
 * Google Fonts a template always needs besides its text styles.
 *
 * @param design Template.
 */
export const getTemplateFonts = ( design: TemplateDesign ): string[] =>
	design.components.countdown.visible &&
	design.components.countdown.variant === 'flip'
		? [ 'Share Tech', 'Lato' ]
		: [];
